module.exports = [
  -83.9610214233, -36.5907516479,
  -83.9610214233, 36.5907516479,
  83.9610214233, 36.5907440186,
  83.9610214233, -36.5907592773

]
